import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "error"]

  connect() {
    this.handleEscape = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.handleEscape)

    const openBtn = this.element.querySelector('[data-action*="login-modal#open"]')
    if (openBtn) {
      openBtn.addEventListener("click", (e) => {
        e.preventDefault()
        this.open()
      })
    }

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("click", (e) => this.closeOnBackdrop(e))
    }

    const params = new URLSearchParams(window.location.search)

    // Auto-open on hidden login URL redirect
    if (params.has("open_login")) {
      this.open()
      history.replaceState(null, "", window.location.pathname)
    }

    // Auto-open with error after failed login
    if (params.has("login_error")) {
      this.open()
      if (this.hasErrorTarget) {
        const code = params.get("login_error")
        if (code === "rate_limited") {
          this.errorTarget.textContent = "Zu viele Versuche. Bitte warte 1 Minute."
        } else if (code === "locked") {
          this.errorTarget.textContent = "Konto gesperrt. Bitte in 1 Stunde erneut versuchen."
        } else {
          this.errorTarget.textContent = "E-Mail oder Passwort ist ungültig."
        }
        this.errorTarget.style.display = "block"
      }
      history.replaceState(null, "", window.location.pathname)
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }

  open() {
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
